import { render, staticRenderFns } from "./NursingLog.vue?vue&type=template&id=2899a610&scoped=true"
import script from "./NursingLog.vue?vue&type=script&lang=js"
export * from "./NursingLog.vue?vue&type=script&lang=js"
import style0 from "./NursingLog.vue?vue&type=style&index=0&id=2899a610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899a610",
  null
  
)

export default component.exports